import {
  CHECK_IN_TAG_INTERACTIONS,
  CHECK_IN_TAGS,
  CheckInTag,
} from '@/experiences/sales-portal/domain/accounts/screens/account-detail/containers/account-detail-check-in/constants';
import { CrmCheckInInteraction } from '@/types';

export const toCheckInInteractions = (
  tags: CheckInTag[],
): CrmCheckInInteraction[] =>
  CHECK_IN_TAGS.filter((tag) => tags.includes(tag)).map(
    (tag) => CHECK_IN_TAG_INTERACTIONS[tag],
  );
